import mock from "../mock"

let data = {
  events: [
    /*{
      id: 1,
      title: "My Event",
      start: new Date(),
      end: new Date(Date.now() + 5 * 24*60*60*1000),
      label: "business",
      allDay: true,
      selectable: true
    },
    {
      id: 2,
      title: "Work to do",
      start: new Date(),
      end: new Date(Date.now() + 5 * 24*60*60*1000),
      label: "work",
      allDay: true,
      selectable: true
    },
    {
      id: 3,
      title: "Something",
      start: new Date(Date.now() + 6 * 24*60*60*1000),
      end: new Date(Date.now() + 7 * 24*60*60*1000),
      label: "others",
      allDay: true,
      selectable: true
    }*/
  ]
}

// GET : Calendar Events
mock.onGet("/api/apps/calendar/events").reply(() => {
  return [200, data.events]
})
